import { colors, spacing } from "../theme";

export default function EnterpriseToolbar({
  searchValue = "",
  onSearchChange,
  searchPlaceholder = "Search...",
  children,
  action,
}) {
  return (
    <div
      style={{
        background: colors.white,
        border: `1px solid ${colors.slate200}`,
        borderRadius: 16,
        padding: spacing.lg,
        display: "grid",
        gap: spacing.md,
      }}
    >
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "minmax(220px, 1fr) auto",
          gap: spacing.md,
          alignItems: "center",
        }}
      >
        <input
          value={searchValue}
          onChange={(e) => onSearchChange?.(e.target.value)}
          placeholder={searchPlaceholder}
          style={{
            padding: 10,
            borderRadius: 10,
            border: `1px solid ${colors.slate200}`,
            fontWeight: 800,
          }}
        />

        {action || null}
      </div>

      {children ? (
        <div style={{ display: "flex", gap: spacing.sm, flexWrap: "wrap" }}>
          {children}
        </div>
      ) : null}
    </div>
  );
}